module.exports = __webpack_public_path__ + "static/media/my-needs-netwell.2baaead8.svg";